import React from 'react';
import BookingListCards from '../booking-list/BookingListCards';
import './UpdateConfirmation.css';

/**
 * Read-only confirmation card for update_booking awaiting_confirmation state.
 * Layout: update header → existing booking card (no click) → diff block (Current/New text).
 * The Yes/Cancel chips are handled by the existing WebChips component above the input.
 *
 * @param {object} booking - bookings[0] from raw_output (current snapshot)
 * @param {string} updateHeader - raw_output.update_header (e.g. "Update booking #KL7JX7B?")
 * @param {string} diffBlock - raw_output.diff_block (preformatted Current:/New: text)
 * @param {function} [onImageLoad] - optional callback when card image loads
 */
const UpdateConfirmationCard = ({ booking, updateHeader, diffBlock, onImageLoad }) => {
  if (!booking) return null;

  return (
    <div className="update-confirmation">
      {updateHeader && (
        <p className="update-confirm-header">{updateHeader}</p>
      )}

      <BookingListCards bookings={[booking]} onImageLoad={onImageLoad} />

      {diffBlock && (
        <pre className="update-diff-block">{diffBlock}</pre>
      )}
    </div>
  );
};

export default React.memo(UpdateConfirmationCard);
